<script>
import ecard from '~/mixins/ecard.vue'

export default {
  mixins: [ecard],

  asyncData({ store, route, params, query, $ua, redirect }) {
    if (!Object.keys(params).length) {
      redirect('/ecard')
    }

    const path = '/ecard'
    console.log(`fetch ECard path=${path}`)

    return {
      isFromMobile: $ua.isFromIphone() || $ua.isFromAndroidMobile(),
      params
    }
  }
}
</script>
